import type { guest } from '@croissants/contracts';
import type { BasketLine } from '../state/basket';

type WireLine = guest.BasketLine;

/**
 * The basket's lines as the guest endpoints want them (CAT-018): the product,
 * how many, and the guest's answers to a formule's questions - and nothing
 * else. The label the guest saw is deliberately NOT sent: a catalogue that
 * renames an item must not look like a new basket and re-quote one.
 *
 * ONE mapping for the quote and the checkout, because the two are priced by
 * the same server code and a line that reaches one without its answers is
 * refused there (the formule's question is unanswered) while the other
 * accepts the very same basket. That is what shipped on 2026-08-29: the
 * checkout page's quote sent `{ itemId, quantity }` and the guest read
 * "choose an option for every part of this formule" on a basket they had
 * just answered in full.
 */
export function wireLinesOf(lines: readonly BasketLine[]): WireLine[] {
  return lines.map((line) => ({
    itemId: line.itemId,
    quantity: line.quantity,
    ...(line.choices === undefined || line.choices.length === 0
      ? {}
      : {
          // A rank and an id, spelled out rather than spread: an answer also
          // carries the words it was chosen by, and those are a label. The
          // body IS the quote's cache key, so sending them would re-quote the
          // same basket the moment the guest switched language.
          choices: line.choices.map((choice) => ({
            componentRank: choice.componentRank,
            itemId: choice.itemId,
          })),
        }),
  }));
}
